// ===== Neapolitan deck definitions & labels (pure data) =====
export const SUITS = ['denari', 'coppe', 'bastoni', 'spade'];

export const SUIT_LABEL = {
  denari: 'denari',
  coppe: 'coppe',
  bastoni: 'bastoni',
  spade: 'spade',
};

export const RANKS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export const RANK_LABEL = {
  1: 'Asso',
  2: 'Due',
  3: 'Tre',
  4: 'Quattro',
  5: 'Cinque',
  6: 'Sei',
  7: 'Sette',
  8: 'Fante',
  9: 'Cavallo',
  10: 'Re',
};

// Short label for the card corner
export const RANK_SHORT = {
  1: 'A',
  2: '2',
  3: '3',
  4: '4',
  5: '5',
  6: '6',
  7: '7',
  8: 'F',
  9: 'C',
  10: 'R',
};

// Primiera point values (per standard classic rules)
export const PRIMIERA_VALUES = {
  7: 21,
  6: 18,
  1: 16,
  5: 15,
  4: 14,
  3: 13,
  2: 12,
  8: 10,
  9: 10,
  10: 10,
};

export function cardId(suit, value) {
  return `${suit}-${value}`;
}

export function makeCard(suit, value) {
  return { id: cardId(suit, value), suit, value };
}

// Natural, human/VoiceOver friendly label -> "Sette di coppe"
export function cardLabel(card) {
  return `${RANK_LABEL[card.value]} di ${SUIT_LABEL[card.suit]}`;
}

export function cardsLabel(cards) {
  return cards.map(cardLabel).join(' più ');
}

export function createDeck() {
  const deck = [];
  for (const suit of SUITS) {
    for (const value of RANKS) {
      deck.push(makeCard(suit, value));
    }
  }
  return deck;
}

export function isSettebello(card) {
  return card.suit === 'denari' && card.value === 7;
}
